import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { selectSelectedLeague, selectTournamentDifficulty, } from "../../selectors/selectTournamentInfo";
import { EventType } from "../balancing/types/BalancingCore";
import { ArrowLeft } from "../generic/common/ArrowLeft";
import { ArrowRight } from "../generic/common/ArrowRight";
import { TabLeagueOverviewContent } from "./TabLeagueOverviewContent";
export var _TabLeaguesOverview = function (_a) {
    var highlightedPlayerLeagueId = _a.highlightedPlayerLeagueId, leagueArray = _a.leagueArray, selectedLeagueIndex = _a.selectedLeagueIndex;
    var _b = useState(selectedLeagueIndex), leagueIndex = _b[0], setLeagueIndex = _b[1];
    var changeLeagueId = function (amount) {
        var finalIndex = leagueIndex + amount;
        if (finalIndex < 0) {
            finalIndex = leagueArray.length - 1;
        }
        else if (finalIndex >= leagueArray.length) {
            finalIndex = 0;
        }
        setLeagueIndex(Object.freeze(finalIndex));
    };
    return (React.createElement("div", { className: "w100 flex flex--aligned flex--around" },
        React.createElement(ArrowLeft, { onClick: function () { return changeLeagueId(-1); } }),
        React.createElement(TabLeagueOverviewContent, { highlightedPlayerLeagueId: highlightedPlayerLeagueId[leagueIndex], selectedLeague: leagueArray[leagueIndex] }),
        React.createElement(ArrowRight, { onClick: function () { return changeLeagueId(1); } })));
};
var mapState = function (state) {
    var leagueArray = [EventType.PlayerLeague, EventType.CoopLeague, EventType.CollectLeague];
    var selectedLeague = selectSelectedLeague(state) || EventType.PlayerLeague;
    var selectedLeagueIndex = leagueArray.findIndex(function (element) { return element === selectedLeague; }) || 0;
    var highlightedPlayerLeagueId = leagueArray.map(function (element) { return selectTournamentDifficulty(state, element) || 0; });
    return {
        highlightedPlayerLeagueId: highlightedPlayerLeagueId,
        leagueArray: leagueArray,
        selectedLeagueIndex: selectedLeagueIndex,
    };
};
export var TabLeaguesOverview = connect(mapState)(_TabLeaguesOverview);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/TabLeaguesOverview.tsx
// module id = 2780
// module chunks = 3